module.exports = __webpack_public_path__ + "img/logo_pastores_600x300.8a56553d.png";